var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h3", { staticClass: "text-center mb-6" }, [
        _vm._v(_vm._s(_vm.$t("roomWizard.selectMeeting")))
      ]),
      _c(
        "div",
        { staticClass: "d-flex mb-4" },
        [
          _c(
            "v-list",
            { staticClass: "mt-4 w-full", attrs: { dense: "" } },
            _vm._l(_vm.providers, function(provider) {
              return _c(
                "div",
                {
                  key: provider.provider,
                  staticClass: "mb-4 border-a border-ra py-2"
                },
                [
                  _c(
                    "v-list-item",
                    [
                      provider.logo
                        ? _c(
                            "v-list-item-avatar",
                            { attrs: { size: "32", rounded: "0" } },
                            [
                              _c("img", {
                                attrs: {
                                  src: provider.logo,
                                  alt: provider.name
                                }
                              })
                            ]
                          )
                        : _vm._e(),
                      _c("v-list-item-content", [
                        _c("div", { staticClass: "font-bold text-xl" }, [
                          _vm._v(_vm._s(provider.name))
                        ]),
                        _vm.dontNeedConnection(provider)
                          ? _c("div")
                          : _vm.isEnabled(provider)
                          ? _c("div", [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("providers.connectedAs")) +
                                  " " +
                                  _vm._s(_vm.getConnectedEmail(provider)) +
                                  " "
                              )
                            ])
                          : _c("div", [
                              _vm._v(_vm._s(_vm.$t("providers.notconnected")))
                            ])
                      ]),
                      _c(
                        "v-list-item-action",
                        [
                          _vm.canToggleActivation(provider)
                            ? _c("va-button", {
                                staticClass: "provider-action-button",
                                attrs: {
                                  color: _vm.isEnabled(provider)
                                    ? "error"
                                    : "neutral",
                                  size: "l",
                                  loading: _vm.loading,
                                  cta: _vm.isEnabled(provider)
                                    ? _vm.$t("providers.disconnect")
                                    : _vm.$t("providers.connect")
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.onToggleActivation(provider)
                                  }
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "px-4" },
                    [
                      _c("va-switch", {
                        key:
                          provider.provider +
                          "-JoinMeeting-" +
                          _vm.switchResetKey,
                        staticClass: "my-1",
                        attrs: {
                          text: _vm.getFeatureText(provider),
                          disabled:
                            _vm.loading ||
                            !_vm.canShowJoinMeetingSwitch(provider),
                          value: _vm.isJoinMeetingEnabled(provider)
                        },
                        on: {
                          input: function($event) {
                            return _vm.onJoinMeetingToggle(
                              provider.provider,
                              $event
                            )
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            }),
            0
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "d-flex justify-space-between my-8" },
        [
          !_vm.first
            ? _c("va-button", {
                staticClass: "mr-4",
                attrs: {
                  color: "secondary",
                  type: "outline",
                  cta: _vm.$t("roomWizard.prev")
                },
                on: { click: _vm.onBack }
              })
            : _c("v-spacer"),
          _c("va-button", {
            attrs: { loading: _vm.loading, cta: _vm.$t("roomWizard.next") },
            on: { click: _vm.onFinish }
          })
        ],
        1
      ),
      _c("safari-login-dialog", {
        attrs: {
          pendingLoginUrl: _vm.pendingLoginUrl,
          callback: _vm.onPopupMeetingClosed
        },
        model: {
          value: _vm.pendingProvider,
          callback: function($$v) {
            _vm.pendingProvider = $$v
          },
          expression: "pendingProvider"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }